export default __webpack_public_path__ + "static/media/midasi_point_vi_sp.55f7aab0.png";